import React, { useContext, useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import { selectedLanguage, formatPrice } from "../../Utility/helper";

function CustomCheckBoxService({ data = [], name, selectedValues, onCheckChange }) {
  const [checkedIds, setCheckedIds] = useState(selectedValues || []); // Initialize state with selectedValues
  const { state } = useContext(AppContext);
  const { language } = state;

  // Handle checkbox change
  const handleCheckChange = (event) => {
    const { value } = event.target;
    // const numericValue = isNaN(value) ? value : Number(value);
    const numericValue = Number(value);

    // Update checkedIds based on current selection
    let nextIds;
    if (checkedIds.includes(numericValue)) {
      nextIds = checkedIds.filter((id) => id !== numericValue);
    } else {
      nextIds = [...checkedIds, numericValue];
    }
    setCheckedIds(nextIds);
    // Notify parent only on user-initiated changes to avoid loops
    onCheckChange(nextIds);
  };

  // Sync with selectedValues prop if it changes
  useEffect(() => {
    setCheckedIds(selectedValues || []);
  }, [selectedValues]);


  return (
    <FormGroup name={name}>
      {(data || []).map((item) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <FormControlLabel
            key={item.id}
            value={item.id}
            control={
              <Checkbox
                checked={checkedIds.includes(item.id)} // Reflect selected values
                onChange={handleCheckChange}
              />
            }
            label={
              <span style={{ fontWeight: "500" }}>
                {selectedLanguage(item, language)}
                {(language === "de"
                  ? item.german_description
                  : item.description) &&
                  item.show_description &&
                  ` ${language === "de" ? item.german_description : item.description
                  }`}
              </span>
            }
          />
          <p
            style={{
              background: "#22A156",
              color: "white",
              padding: "10px",
              margin: "0px",
              borderRadius: "50px",
              minWidth: "67px",
              textAlign: "center",
              textWrap: "nowrap",
            }}
          >
            {formatPrice(item.amount, language)} &#8364;
          </p>
        </div>
      ))}
    </FormGroup>
  );
}

export default CustomCheckBoxService;
